import './js/btn-up';
import './js/loader';
import './js/movie-api';
import './js/create-card';
import './js/filter';
import './js/modal-film-info';
import './js/modal-trailer';
import './js/pagination-main';
import './js/modal-footer';
